import {
    REQUEST_SERVICES_ROUTE,
    REQUEST_SERVICES_ROUTE_FAILURE,
    REQUEST_SERVICES_ROUTE_SUCCESS
} from "../../../constant/transaction/ShipmentConstant";


const initialState = {
    serviceRoutes: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const serviceRoutesReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_SERVICES_ROUTE:
            return {
                ...state,
                serviceRoutes: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_SERVICES_ROUTE_SUCCESS:
            return {
                ...state,
                serviceRoutes: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_SERVICES_ROUTE_FAILURE:
            return {
                ...state,
                serviceRoutes: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
